import { createContext } from 'react';

const ClaimDetailsContext = createContext<null | Record<string, string>>(null);

export default ClaimDetailsContext;